module.exports = __webpack_public_path__ + "assets/dict.e54d50d6.svg";